import { requestFromServer } from "./api-client";

const Quotas = {
  multipleSave: async(clientQuota) => {
    return requestFromServer(`v1/Quotas/add`, "POST", clientQuota);
  },
  listByClient: async (idPlant, startDate, endDate, idTimeBlock) => {
    if (!!idTimeBlock){
      return requestFromServer(`v1/Quotas/list/${idPlant}/${startDate}/${endDate}/${idTimeBlock}`);
    } else {
      return requestFromServer(`v1/Quotas/list/${idPlant}/${startDate}/${endDate}`);
    }
  },
  addEmptyQuota: async (clientQuota) => {
    return requestFromServer(`v1/Quotas/addEmptyQuota`, "POST", clientQuota);
  },
  update: async (clientId) => {
    return requestFromServer(`v1/Quotas/update`, "PUT", clientId);
  },
  delete: async (id) => {
    return requestFromServer(`v1/Quotas/delete/${id}`, "delete");
  },
};

export default Quotas;
